import { getOr, size, split } from 'lodash/fp';

export const createSrcSet = (src: string, widthSet: number[], ratio: number): string =>
    widthSet.reduce(
        (acc, sourceSetWidth) => acc + `${createSrcWithSizes(src, sourceSetWidth, ratio)} ${sourceSetWidth}w,`,
        ''
    );

export const createSrcWithSizes = (src: string, sourceSetWidth: number, ratio: number): string => {
    const height = Math.round(sourceSetWidth / ratio);
    const sizeQueryString = `width=${sourceSetWidth}&height=${height}`;

    const srcParts = split('?', src);
    const imageSrcWithoutQueryString = getOr('', 0, srcParts);
    const originalSrcQueryString = getOr('', 1, srcParts);
    const queryStringSeparator = size(originalSrcQueryString) > 0 ? '&' : '';
    const finalQueryString = `?${originalSrcQueryString}${queryStringSeparator}${sizeQueryString}`;

    return `${imageSrcWithoutQueryString}${finalQueryString}`;
};
